import { render, staticRenderFns } from "./CustomerCareLinks.vue?vue&type=template&id=6c878d6b"
import script from "./CustomerCareLinks.vue?vue&type=script&lang=js"
export * from "./CustomerCareLinks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports